import { AuthUserType } from "../../../auth/types";
import { Role } from "../../../auth/types/roles";

/**
 * Filters navigation config to only include items the current user's role
 * is allowed to see. Items with `roles: null` are visible to everyone.
 * Sections with no visible items are removed entirely.
 */
export const filterNavByRole = (navConfig: any[], user: AuthUserType | null): any[] => {
  if (!user || !user.roleId) return navConfig;

  const userRole = user.roleId as Role;

  return navConfig
    .map((section) => ({
      ...section,
      items: section.items.filter((item: any) => {
        // null means visible to every authenticated user
        if (!item.roles) return true;
        return (item.roles as Role[]).includes(userRole);
      }),
    }))
    .filter((section) => section.items.length > 0);
};
